var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProviding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.25 84.6875H84.6875V61.25C84.6875 58.6612 82.5888 56.5625 80 56.5625C77.4112 56.5625 75.3125 58.6612 75.3125 61.25V84.6875H23.75C21.1612 84.6875 19.0625 86.7862 19.0625 89.375V117.5C19.0625 120.089 21.1612 122.188 23.75 122.188C26.3388 122.188 28.4375 120.089 28.4375 117.5V94.0625H75.3125V117.5C75.3125 120.089 77.4112 122.188 80 122.188C82.5888 122.188 84.6875 120.089 84.6875 117.5V94.0625H131.562V117.5C131.562 120.089 133.661 122.188 136.25 122.188C138.839 122.188 140.938 120.089 140.938 117.5V89.375C140.938 86.7862 138.839 84.6875 136.25 84.6875Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.125 65.9375H51.875C49.2862 65.9375 47.1875 63.8388 47.1875 61.25V4.6875C47.1875 2.09875 49.2862 0 51.875 0H108.125C110.714 0 112.812 2.09875 112.812 4.6875V61.25C112.812 63.8388 110.714 65.9375 108.125 65.9375Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 160H4.6875C2.09875 160 0 157.901 0 155.312V117.5C0 114.911 2.09875 112.812 4.6875 112.812H42.5C45.0888 112.812 47.1875 114.911 47.1875 117.5V155.312C47.1875 157.901 45.0888 160 42.5 160Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.312 160H117.5C114.911 160 112.812 157.901 112.812 155.312V117.5C112.812 114.911 114.911 112.812 117.5 112.812H155.312C157.901 112.812 160 114.911 160 117.5V155.312C160 157.901 157.901 160 155.312 160Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.75 160H61.25C58.6612 160 56.5625 157.901 56.5625 155.312V117.5C56.5625 114.911 58.6612 112.812 61.25 112.812H98.75C101.339 112.812 103.438 114.911 103.438 117.5V155.312C103.438 157.901 101.339 160 98.75 160Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 80,
    y1: 122.188,
    x2: 80,
    y2: 56.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#E2FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2FFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 80,
    y1: 65.9375,
    x2: 80,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.5938,
    y1: 160,
    x2: 23.5938,
    y2: 112.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 136.406,
    y1: 160,
    x2: 136.406,
    y2: 112.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 80,
    y1: 160,
    x2: 80,
    y2: 112.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProviding);
export default __webpack_public_path__ + "static/media/ic-providing.ea69bafe89ff0ae54cf6bb5f6a8e1861.svg";
export { ForwardRef as ReactComponent };